import { render, staticRenderFns } from "./repairInfo.vue?vue&type=template&id=0c1947a1&scoped=true&"
import script from "./repairInfo.vue?vue&type=script&lang=js&"
export * from "./repairInfo.vue?vue&type=script&lang=js&"
import style0 from "./repairInfo.vue?vue&type=style&index=0&id=0c1947a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1947a1",
  null
  
)

export default component.exports